import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(
  ({ palette, typography, customShadows, spacing, breakpoints }) => {
    const ITEM_HEIGHT = 56
    return {
      list: {
        maxHeight: ITEM_HEIGHT * 6,
        [breakpoints.up('sm')]: {
          width: 250
        }
      },
      item: {
        height: ITEM_HEIGHT,
        padding: '7px 8px',
        '&.Mui-selected': {
          border: 'none'
        }
      },
      checkbox: {
        marginLeft: spacing(-1),
        color: palette.grey.shade[30],
        '&.Mui-checked': {
          color: palette.primary.main
        }
      },
      label: {
        textTransform: 'capitalize'
      },
      count: {
        color: palette.grey.shade[70],
        fontWeight: 700
      }
    }
  }
)
